module.exports = __webpack_public_path__ + "img/aerLogo.54cf54be.jpg";